import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import { HeaderStepper } from '../Common/HeaderStepper/HeaderStepper';
import LTCData from '../../Helpers/Data/Products/LTC/LTCData';
import * as Steps from './steps';
import { saveSessionEvent } from "../../../session";
import { getSessionStorageItem, setSessionStorageItem, getBasicInfo } from '../../../sessionStorage';
import { JourneyTypes } from '../../Helpers/Constants/JourneyTypes';

export default function LTC(props) {

  const ltcData = LTCData();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => { saveSessionEvent() }, [location])

  const SESSION_STORAGE_KEY = "COVR_LTC";
  var sessionStorageFormState = getSessionStorageItem(SESSION_STORAGE_KEY);

  if (props.landing && sessionStorageFormState) {
    sessionStorageFormState.currentStep = 0;
  }

  const path = location ? location.pathname.split("/").pop() : null;
  const prefill = location && location.search && location.search.toLowerCase().includes('prefill');

  const basicInfo = getBasicInfo();

  const newFormState = {
    currentStep: 0,
    pages: {
      appointment: Steps.Appointment.DefaultFormState(prefill, basicInfo)
    },
  };

  const initialFormState = sessionStorageFormState || newFormState;

  const [formState, setFormState] = useState(initialFormState);

  // update the formState when the url path changes the step
  useEffect(() => {
    if (!path || path === steps[formState.currentStep].path) {
      return;
    }

    const nextStep = steps.findIndex(s => s.path === path);

    if (nextStep < 0) {
      return;
    }

    const newFormState = { ...formState, currentStep: nextStep };
    setFormState(newFormState);
  }, [path]);

  const onNext = () => {
    if (formState.currentStep >= steps.length - 1) {
      console.error("No next step!");
      return;
    }

    const nextStepPath = steps[formState.currentStep + 1].path;
    const newFormState = { ...formState, currentStep: formState.currentStep + 1 };

    setFormState(newFormState);
    setSessionStorageItem(SESSION_STORAGE_KEY, newFormState);

    navigate(`/quote/long-term-care/${nextStepPath}`);
    window.scroll(0, 0);
  };

  const onBack = () => {
    if (formState.currentStep <= 1) {
      navigate('/landing/long-term-care');
      return;
    }

    const backStepPath = steps[formState.currentStep - 1].path;
    const newFormState = { ...formState, currentStep: formState.currentStep - 1 };

    setFormState(newFormState);
    setSessionStorageItem(SESSION_STORAGE_KEY, newFormState);

    navigate(`/quote/long-term-care/${backStepPath}`);
    window.scroll(0, 0);
  };

  const onFieldChange = (step, field, value) => {
    setFormState({ ...formState, pages: { ...formState.pages, [step]: { ...formState.pages[step], [field]: value } } });
  };

  const steps = [
    {
      path: 'basic-info',
      progressTitle: 'Basic Information',
      component: (
        <Steps.BasicInfo
          formState={formState.pages.appointment}
          onFieldChange={(field, value) => onFieldChange('appointment', field, value)}
          onNext={onNext}
          onBack={onBack}
          hideBack={props.landing}
          ageSpecs={ltcData.specs.age}
        />
      ),
    },
    {
      path: 'schedule-appointment',
      progressTitle: 'We Are Here To Serve You',
      component: <Steps.Appointment
        formState={formState.pages.appointment}
        quoter={{ product: 'Long Term Care', specialNote: 'Requesting quote for LTC' }}
        basicInfo={{...basicInfo, ...formState.pages.appointment}}
        onFieldChange={(field, value) => onFieldChange('appointment', field, value)}
        onNext={onNext}
        onBack={onBack}
        summaryTitle="Quote Request"
        product={ltcData.name}
        journeyType={JourneyTypes.QUOTE_REQUEST}
        showStateDropdown
        isAppointmentSchedulingEnabled={true}
        isDropTicket={true}
        baseURL={'/quote/long-term-care/schedule-appointment'}
        setMultiField={(firstName,lastName,email)=>{setFormState({ ...formState, pages: { ...formState.pages, appointment: { ...formState.pages.appointment, firstName: firstName, lastName: lastName, email: email } } })
        sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(formState));
      }}  
      fullFormState={formState}
      onMultiFieldChange={(fs) => {setFormState(fs)}}    
      />,
      hideProgressTracker: true,
      headerText: 'We Are Here To Serve You',
      whiteBackground: true,
      hideMainHeader: true,
    },
    {
      path: 'thank-you',
      headerText: 'Verifying Your Information',
      component: <Steps.ThankYou 
        sessionStorageKey={SESSION_STORAGE_KEY}
        name={formState.pages.appointment.firstName}
        date={formState.pages.appointment.specificApptTime}
        basicInfo={basicInfo} />,
      hideProgressTracker: true,
      hideMainHeader: false,
      progressTitle: 'ThankYou'
    }
  ];

  const currentStepObj = steps[formState.currentStep];

  return (
    <div>
      <Helmet>
        <title>{`Long Term Care - ${currentStepObj?.progressTitle}`}</title>
      </Helmet>
      <HeaderStepper
        title={currentStepObj.headerText}
        hidden={props.landing || currentStepObj.hideMainHeader}
        hideProgressTracker={currentStepObj.hideProgressTracker}
        stepName={currentStepObj.progressTitle}
        step={formState.currentStep + 1}
        totalSteps={steps.length}
        whiteBg={currentStepObj.whiteBackground}
      >
        {currentStepObj.component}
      </HeaderStepper>
    </div>
  );
}

LTC.propTypes = {
  landing: PropTypes.bool,
};
